import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomInput from "../../../../Components/input/CustomInput";
import CustomButton from "../../../../Components/Button/CustomButton";
import { GetProductCategory } from "../../../../APIs/Function/ProductCategory/GetProductCategory";
import { handleAddProductCategory } from "../../../../APIs/Function/ProductCategory/AddProductCategory";
import bin from "../../../../Utils/Images/bin.svg";
import pen from "../../../../Utils/Images/editbox.png";
import DeleteModal from "../../../../Components/Modal/DeleteModal";
import { DeleteProductCategory } from "../../../../APIs/Function/ProductCategory/DeleteProductCategory";

const ProductCategory = () => {
  const [data, setData] = useState([]);
  const [category, setCategory] = useState("");
  const [open, setOpen] = useState(false);
  const [modalID, setModalID] = useState("");
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("ADD");
  const [id, setId] = useState(null);
  const handleProductCategory = async () => {
    try {
      let res = await GetProductCategory();
      setData(res.r);
      setCategory("");
    } catch (error) {
      console.log(error);
    }
  };
  const handleClose = () => {
    setOpen(!open);
  };

  console.log(data);

  const handleDelete = async (modalID) => {
    try {
      setOpen(false);
      let res = await DeleteProductCategory(modalID);
      if (res.s) {
        handleProductCategory();
        alert("Product Category Delete Successfully");
      }
    } catch (error) {
      console.error("Error deleting product category", error);
    }
  };

  const handleModal = (id) => {
    setModalID(id);
    setOpen(true);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      if (category.trim() !== "") {
        let res = await handleAddProductCategory(category, id);
        if (res.s) {
          handleProductCategory();
          setCategory("");
          if (id) {
            alert("Product Category Edited Successfully");
          } else {
            alert("Product Category Added Successfully");
          }
          setType("ADD");
          setId(null);
        } else {
          alert("Failed to add product category");
        }
        setLoading(false);
      } else {
        alert("Product Category is Required");
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleEdit = async (e) => {
    setCategory(e.category);
    setType("Edit");
    setId(e.id);
  };

  useEffect(() => {
    handleProductCategory();
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        p: 1,
        boxSizing: "border-box",
        gap: "10px",
        height: "80vh",
      }}
    >
      <Box sx={{ width: "50%" }}>
        <Typography sx={{ textAlign: "left", fontWeight: 500 }}>
          ADD PRODUCT CATEGORY
        </Typography>
        <Box
          sx={{
            width: "100%",
            height: "80vh",
            display: "flex",
            gap: "10px",
            mt: "10px",
          }}
        >
          <CustomInput
            label="Product Category"
            name="productcategory"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            sx={{ width: "80%" }}
            autoComplete="off"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            }}
          />
          <CustomButton
            disabled={loading}
            onClick={handleSubmit}
            sx={{ height: "55px", width: "20%" }}
          >
            {loading ? <CircularProgress /> : type}
          </CustomButton>
        </Box>
      </Box>
      {/* Product Category List */}
      <Box sx={{ width: "50%" }}>
        <Typography sx={{ textAlign: "left", fontWeight: 500 }}>
          Product Category List
        </Typography>
        <Box
          sx={{
            border: "1px solid #000",
            width: "100%",
            maxHeight: "80vh",
            overflow: "auto",
            minHeight: "10px",
            borderRadius: "10px",
            p: 1,
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          {data.length ? (
            data?.map((e, i) => (
              <Box
                key={i}
                sx={{
                  textAlign: "left",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  bgcolor: "lightgray",
                  borderRadius: "10px",
                  p: 1,
                  boxSizing: "border-box",
                }}
              >
                <Typography>{e.category}</Typography>
                <Box sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
                  <Box
                    onClick={() => handleEdit(e)}
                    sx={{ width: "30px", height: "30px" }}
                  >
                    <img
                      width={"100%"}
                      height={"100%"}
                      src={pen}
                      alt="preview"
                    />
                  </Box>
                  <Box
                    sx={{ width: "30px", height: "30px" }}
                    onClick={() => handleModal(e.id)}
                  >
                    <img
                      width={"100%"}
                      height={"100%"}
                      src={bin}
                      alt="preview"
                    />
                  </Box>
                </Box>
              </Box>
            ))
          ) : (
            <Typography>No Data</Typography>
          )}
        </Box>
      </Box>
      <DeleteModal
        open={open}
        handleDelete={handleDelete}
        modalID={modalID}
        onClose={handleClose}
      />
    </Box>
  );
};

export default ProductCategory;
